export default __webpack_public_path__ + "521f01d2781b140fabfa5afe01556234.png";